import { render } from "./MissingDetail.vue?vue&type=template&id=96888824&scoped=true"
import script from "./MissingDetail.vue?vue&type=script&lang=js"
export * from "./MissingDetail.vue?vue&type=script&lang=js"

import "./MissingDetail.vue?vue&type=style&index=0&id=96888824&scoped=true&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96888824"]])

export default __exports__